export default __webpack_public_path__ + "static/media/card.ddc84cd2.svg";